
const Home = {
  init() {

  },


};

export default Home;
